import styled from 'styled-components';
import BoostFloralLogo from '../../../app/components/svgIcons/BoostFloralLogo';
import StyledText from '../../../app/components/styledComponents/StyledText';
import { Container, Row, Col } from 'react-bootstrap';
import moment from 'moment';

const FooterWrapper = styled.footer`
  background: var(--BG-Color, #f2f2f2);

  .divider {
    border-right: 1px solid #d1d1d1;
  }

  .wrapper {
    max-width: 1440px;
    padding: 6rem 8.75rem 0 8.75rem;
    overflow: hidden;
    margin: 0 auto;
  }

  .footer-content {
    margin-bottom: 3rem;
    display: flex;
    align-items: start;

    .left {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
    }
  }

  .footer-links-container {
    width: 25%;
  }

  .footer-heading {
    color: var(--font-color-font-1, #1b131f);
    font-family: Instrument Sans;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 26px;
    margin-bottom: 1rem;
  }

  .footer-links {
    display: flex;
    padding: 8px 0px;
    color: var(--font-color-font-2, #666467);
    font-family: Instrument Sans;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
  }

  .footer-divider {
    height: 2px;
    background: #b4b2b5;
  }

  .dot {
    height: 25px;
    width: 25px;
    border: 1px solid var(--font-color-font-2, #666467);
    border-radius: 50%;
    display: inline-block;
    color: var(--font-color-font-2, #666467);
    text-align: center;
  }

  .footer-copyright {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 3.125rem 0 3rem 0;

    p {
      color: var(--font-color-font-2, #666467);
      font-family: Instrument Sans;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 24px;
    }

    .desktop-footer-text {
      display: block;
    }

    .mobile-footer-text {
      display: none;
    }

    .social-links {
      display: flex;
      gap: 1rem;
    }
  }

  @media screen and (max-width: 1024px) {
    .wrapper {
      padding: 6rem 3.75rem 0 3.75rem;
    }
  }

  @media screen and (max-width: 768px) {
    .wrapper {
      padding: 2rem 1.25rem 0 1.25rem;
    }

    .footer-content {
      margin-bottom: 3rem;
      flex-wrap: wrap-reverse;
      justify-content: center;
      gap: 1.5rem;

      .left {
        width: 100%;
        display: flex;
        gap: 1.5rem;
      }
    }

    .footer-links-container {
      width: 45%;
    }

    .footer-heading {
      color: var(--font-color-font-1, #1b131f);
      font-family: Instrument Sans;
      font-size: 18px;
      font-style: normal;
      font-weight: 600;
      line-height: 26px;
      margin-bottom: 1rem;
    }

    .footer-links {
      display: flex;
      padding: 8px 0px;
      color: var(--font-color-font-2, #666467);
      font-family: Instrument Sans;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 24px;
    }

    .footer-divider {
      height: 2px;
      background: #b4b2b5;
    }

    .dot {
      height: 25px;
      width: 25px;
      border: 1px solid var(--font-color-font-2, #666467);
      border-radius: 50%;
      display: inline-block;
      color: var(--font-color-font-2, #666467);
      text-align: center;
    }

    .footer-copyright {
      display: flex;
      flex-direction: column-reverse;
      justify-content: space-between;
      align-items: center;
      gap: 0.725rem;
      padding: 0;
      margin: 1.5rem 0 2rem 0;

      .desktop-footer-text {
        display: none;
      }

      .mobile-footer-text {
        display: block;
      }

      p {
        font-size: 14px;
        line-height: 22px;
        text-align: center;
      }
    }
  }

  @media screen and (max-width: 475px) {
    .divider {
      border-right: none;
    }
  }
`;

const FooterNew = () => {
  return (
    <FooterWrapper>
      <div className="wrapper">
        <Container>
          <Row className="g-3 align-items-stretch">
            <Col xs={12} md={6} lg={4} className="divider">
              <h3 className="footer-heading">Contact Us</h3>
              <StyledText
                newFont
                $fontSize="16px"
                $fontWeight="400"
                color="bodyMedium"
              >
                (888) 575-3858
              </StyledText>
              <div className="mt-3">
                <StyledText
                  newFont
                  $fontSize="16px"
                  $fontWeight="400"
                  href="mailto:sales@boostfloral.com"
                  className="text-decoration-underline"
                  as="a"
                >
                  sales@boostfloral.com
                </StyledText>
                <StyledText
                  newFont
                  $fontSize="16px"
                  $fontWeight="400"
                  color="bodyMedium"
                >
                  For questions about subscriptions
                </StyledText>
              </div>
              <div className="mt-3">
                <StyledText
                  newFont
                  $fontSize="16px"
                  $fontWeight="400"
                  href="mailto:support@boostfloral.com"
                  className="text-decoration-underline"
                  as="a"
                >
                  support@boostfloral.com
                </StyledText>
                <StyledText
                  newFont
                  $fontSize="16px"
                  $fontWeight="400"
                  color="bodyMedium"
                >
                  For help setting up your website
                </StyledText>
              </div>
              <div className="mt-3">
                <StyledText
                  newFont
                  $fontSize="16px"
                  $fontWeight="400"
                  href="mailto:info@boostfloral.com"
                  className="text-decoration-underline"
                  as="a"
                >
                  info@boostfloral.com
                </StyledText>
                <StyledText
                  newFont
                  $fontSize="16px"
                  $fontWeight="400"
                  color="bodyMedium"
                >
                  For general inquires, partnering details,
                  <br />
                  or web design consulting
                </StyledText>
              </div>
            </Col>
            <Col
              xs={12}
              md={6}
              lg={4}
              className="d-flex flex-column align-items-start align-items-md-center justify-content-start justify-content-md-center"
            >
              <Row className='w-75'>
               <h3 className="footer-heading">Legal</h3>
                <a style={{paddingLeft : '11px'}} href="/privacy-policy" className="footer-links">
                  Privacy Policy
                </a>
                <a style={{paddingLeft : '11px'}} href="/terms-and-conditions" className="footer-links">
                  Terms and Conditions
                </a>
              </Row>
              <Row className='w-75'>
               <Col>
               <Row>
               <h3 className="footer-heading mt-3">Resources</h3>
               </Row>
               <Row>
               <Col md={6} xs={12} className=''>
                <a href="/partners" className="footer-links">
                  Partners
                </a>
                <a href="/blogs" className="footer-links">
                  Blogs
                </a>
                <a href="/social" className="footer-links">
                  Social
                </a>
                </Col>
               <Col md={6} xs={12} className=''>
               <a href="/our-process" className="footer-links">
                  Our Process
                </a>
                <a href="/our-videos" className="footer-links">
               Our Videos
                </a>
                <a href="/pos-system" className="footer-links">
                  POS Systems
                </a>
               </Col>
               </Row>
               </Col>
              </Row>
              
               
            </Col>
            <Col
              md={12}
              lg={4}
              className="d-flex flex-column flex-md-row flex-lg-column align-items-end justify-content-between"
            >
              <div>
                <BoostFloralLogo />
              </div>
            </Col>
          </Row>
        </Container>
        <hr className="footer-divider" />
        <div className="footer-copyright">
          <div className="desktop-footer-text">
            <p className="d-flex align-items-center">
              &copy; {moment().year()} BoostFloral &nbsp; | &nbsp;{' '}
              <a href="/privacy-policy" className="footer-links">
                Privacy Policy
              </a>{' '}
              &nbsp; &bull; &nbsp;{' '}
              <a href="/terms-and-conditions" className="footer-links">
                Terms of use
              </a>
            </p>
          </div>
          <div className="mobile-footer-text">
            <p>&copy; 2023 BoostFloral</p>
            <p className="d-flex align-items-center">
              <a href="/privacy-policy" className="footer-links">
                Privacy Policy
              </a>{' '}
              &nbsp; &bull; &nbsp;{' '}
              <a href="/terms-and-conditions" className="footer-links">
                Terms of use
              </a>{' '}
              &nbsp; &bull; &nbsp; Dispute Policy
            </p>
          </div>
          <div className="social-links">
            <div>
              <StyledSocialIconCover>
                <a
                  href="https://www.facebook.com/BoostFloral"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fa fa-facebook fa-lg" />
                </a>
              </StyledSocialIconCover>
            </div>
            <div>
              <StyledSocialIconCover>
                <a
                  href="https://www.instagram.com/boostfloral"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fa fa-instagram fa-lg" />
                </a>
              </StyledSocialIconCover>
            </div>
            <div>
              <StyledSocialIconCover>
                <a
                  href="https://twitter.com/BoostFloral"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fa fa-twitter fa-lg" />
                </a>
              </StyledSocialIconCover>
            </div>
            <div>
              <StyledSocialIconCover>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.youtube.com/@BoostFloral"
                >
                  <i className="fa fa-youtube-play" />
                </a>
              </StyledSocialIconCover>
            </div>
          </div>
        </div>
      </div>
    </FooterWrapper>
  );
};

const StyledSocialIconCover = styled.div`
  background-color: #62aa48;
  width: 32px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 100%;

  a {
    color: #ffffff;
  }
`;

export default FooterNew;
